import Navbar from '../../components/Navbar/Navbar';
import RoomsContainer from '../../components/RoomsContainer/RoomsContainer';
import QueryModule from '../../components/QueryModule/QueryModule';
import HeroCol from '../../components/HeroCol/HeroCol';
import { AppContext } from '../../components/AppContext/AppContext';
import { useContext,useEffect } from 'react';
import { ModifySummary } from '../../components/ModifySummary/ModifySummary';
import { NavLink} from 'react-router-dom';
import logo from '../../logo_2022.png';


const Home = ({rooms,performSearch,params,handleDateRangeChange,handleDateGuestChange,searchMessage,handleRoomRateSelection,handleRateDetails,rateDetail,exitEditMode,prevRes,handlePreviousResDetails,sortRooms,year}) => {
  
  
  
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', height: '30vh', textAlign: 'center', paddingTop: '20vh' }}>
          <img src={logo} alt="LT Logo" width="200px"/>
      <br/> 
      <div>
        <h1>Site under construction</h1>
      </div>
    </div>
  );
}

export default Home;
